import React, { useState } from 'react'
import { viemaxImgUrls } from '../../../constants/viemax-constants'
const OurStories = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handlePlayVideo = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div className="bg-[linear-gradient(161deg,_#EFD977_0.01%,_#BC892D_98.99%)]">
      <div className="px-6 py-[40px]">
        <div className="space-y-4">
          <h3 className="text-xl font-semibold">Viemax Stories</h3>

          <p className="text-2xl font-semibold">
            "Viemax transformed my habits! Nutrition consultation and curated
            content were so helpful. Highly recommend it!"
          </p>
        </div>
      </div>
      {/* video section */}
      <div className="max-w-[420px] mx-auto relative">
        <div
          className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 hidden"
          onClick={handlePlayVideo}
        >
          <img src={viemaxImgUrls.playIcon} alt="play" className="w-14 h-14" />
        </div>
        <img src={viemaxImgUrls.ourStories.thumbnail} alt="viemax-stories" />
      </div>
      {/* Bottom section */}
      <div className="relative -bottom-1 mt-20">
        <img
          src={viemaxImgUrls.ourStories.bottomWhiteBg}
          alt="viemax-stories"
          className="w-full"
        />
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center h-screen z-[999]">
          <div className="bg-white py-4 px-1 rounded h-[calc(100vh-100px)] w-[calc(100vw-20px)] overflow-hidden">
            <div className="flex justify-end pb-1">
              <button onClick={handleCloseModal} className="text-red-500">
                Close
              </button>
            </div>
            <iframe
              className="h-[calc(100%-20px)] w-full"
              src={viemaxImgUrls.ourStories.videoUrl}
              title={viemaxImgUrls.ourStories.title}
              frameborder="0"
              allow="autoplay; clipboard-write; encrypted-media; gyroscope;"
              allowfullscreen
              style={{ aspectRatio: '16/9' }}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default OurStories
